'use client';

import {type FC, memo} from 'react';

interface PointsVideoAnimationProps {
  isActive: boolean;
  className?: string;
  videoUrl?: string;
}

/**
 * Компонент для отображения анимации камушка при увеличении поинтов
 * @param isActive - Флаг активности анимации
 * @param className - Дополнительные классы для видео
 * @param videoUrl - URL видео файла
 */
export const PointsVideoAnimation: FC<PointsVideoAnimationProps> = memo(
  ({isActive, className = '', videoUrl = '/images/points-video.webm'}) => {
    if (!isActive) {
      return null;
    }
    return (
      <video
        src={videoUrl}
        className={`pointer-events-none absolute inset-0 select-none object-contain ${className}`}
        autoPlay
        muted
        playsInline
        loop
        style={{
          zIndex: 10,
        }}
      />
    );
  },
);

PointsVideoAnimation.displayName = 'PointsVideoAnimation';
